import moment from 'moment';

export function getRemainingTimeSimple(endDate) {
  const start = moment(); // ⏱ now
  const end = moment(endDate);

  const durationMs = Math.max(end.diff(start), 0);
  const duration = moment.duration(durationMs);

  const days = Math.floor(duration.asDays());
  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();

  const parts = [];
  if (days > 0) parts.push(`${days}d`);
  if (hours > 0 || days > 0) parts.push(`${hours}h`);
  if (minutes > 0 || hours > 0 || days > 0) parts.push(`${minutes}m`);
  parts.push(`${seconds}s`);

  return parts.join(' ');
}

export function getProgressPercent(createdAt, currentAt, endAt) {
  const now = moment(currentAt || Date.now());
  const start = moment(createdAt);
  const end = moment(endAt);

  if (!start.isValid() || !end.isValid()) return 0;

  const totalDuration = end.diff(start); // in ms
  const elapsed = now.diff(start);       // in ms

  let percent = (elapsed / totalDuration) * 100;

  // Clamp between 0% and 100%
  if (percent < 0) percent = 0;
  if (percent > 100) percent = 100;

  return Math.round(percent); // Round to nearest %
}



// WEBPACK FOOTER //
// ./src/utils/time.js